import { render, staticRenderFns } from "./NavSideMenu.vue?vue&type=template&id=bb043b22"
import script from "./NavSideMenu.vue?vue&type=script&lang=js"
export * from "./NavSideMenu.vue?vue&type=script&lang=js"
import style0 from "./NavSideMenu.vue?vue&type=style&index=0&id=bb043b22&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports